// DS: i4.45 Daily Challenge
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const DailyChallenge: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M7.057 2a.345.345 0 00-.299.171L3.046 8.57a.342.342 0 00.3.513H7.26l-2.57 5.43a.342.342 0 00.311.488h.218a.484.484 0 00.367-.169l6.33-7.386a.342.342 0 00-.262-.564H8.878l-.205-.244 2.376-4.125a.342.342 0 00-.3-.512H7.058z"
        />
      </svg>
    </IconWrap>
  );
};
DailyChallenge.displayName = 'DailyChallenge';

export default DailyChallenge;
